import React from "react";
import {
  AccessTimeOutlined,
  BadgeOutlined,
  BusinessOutlined,
  CheckCircleOutlined,
  InfoOutlined,
  LinkOutlined,
  NumbersOutlined,
  PersonOutlineOutlined,
  UpdateOutlined,
} from "@mui/icons-material";
import { Box, Grid } from "@mui/material";
import ReactHtmlParser from "html-react-parser";
import InfoGridSkeleton from "components/Shared/Skeleton/InfoGridSkeleton";
import InformationTile from "components/Shared/InformationTile";
import { localizeDateMed } from "utils/dateFormats";
import OpenInNewTab from "components/Shared/OpenInNewTab";
import { useAuth } from "hooks";

const PaymentAccountBasicDetail = ({
  paymentAccountDetail,
  loadingPaymentAccount,
}) => {
  const { isVendor } = useAuth();
  if (loadingPaymentAccount) return <InfoGridSkeleton />;

  return (
    <Box padding={3}>
      <Grid container spacing={4}>
        <Grid item md={3}>
          <InformationTile
            icon={() => <BusinessOutlined color="primary" />}
            title="Account"
            subtitle={paymentAccountDetail?.account?.name ?? "N/A"}
          />
        </Grid>
        <Grid item md={3}>
          <InformationTile
            icon={() => <BadgeOutlined color="primary" />}
            title="Entity"
            subtitle={paymentAccountDetail?.entity?.name ?? "N/A"}
          />
        </Grid>
        <Grid item md={3}>
          <InformationTile
            icon={() => <PersonOutlineOutlined color="primary" />}
            title="Account Name"
            subtitle={paymentAccountDetail?.accountName ?? "N/A"}
          />
        </Grid>
        <Grid item md={3}>
          <InformationTile
            icon={() => <NumbersOutlined color="primary" />}
            title="Account Number"
            subtitle={paymentAccountDetail?.accountNumber ?? "N/A"}
          />
        </Grid>
        <Grid item md={3}>
          <InformationTile
            icon={() => <LinkOutlined color="primary" />}
            title="Linked Type"
            subtitle={
              paymentAccountDetail?.sourceModel === "VendorProfile"
                ? "Vendor Profile"
                : paymentAccountDetail?.sourceModel === "Customer"
                ? "Customer Profile"
                : paymentAccountDetail?.sourceModel === "Contractor"
                ? "Contractor Profile"
                : "N/A"
            }
          />
        </Grid>
        <Grid item md={3}>
          <InformationTile
            icon={() => <LinkOutlined color="primary" />}
            title="Linked Reference"
            subtitle={
              paymentAccountDetail?.sourceModelRef?._id
                ? (() => {
                    const ref = paymentAccountDetail.sourceModelRef;
                    const label =
                      ref.name ||
                      ref.vendor?.name ||
                      ref.customerUser?.name ||
                      "N/A";
                    let link = "#";

                    if (ref.vendor) {
                      link = `/app/crm/vendor-profile/${ref._id}/detail`;
                    } else if (ref.customerUser) {
                      link = `/app/crm/customerProfile/${ref._id}/detail`;
                    } else {
                      link = `/app/crm/contractor/${ref._id}/detail`;
                    }

                    return isVendor ? (
                      <span>{label}</span>
                    ) : (
                      <OpenInNewTab label={label} link={link} />
                    );
                  })()
                : "N/A"
            }
          />
        </Grid>

        <Grid item md={3}>
          <InformationTile
            icon={() => <CheckCircleOutlined color="primary" />}
            title="Status"
            subtitle={paymentAccountDetail?.isActive ? "Active" : "Inactive"}
          />
        </Grid>
        <Grid item md={3}>
          <InformationTile
            icon={() => <AccessTimeOutlined color="primary" />}
            title="Created At"
            subtitle={
              paymentAccountDetail?.createdAt
                ? localizeDateMed(paymentAccountDetail?.createdAt)
                : "N/A"
            }
          />
        </Grid>
        <Grid item md={3}>
          <InformationTile
            icon={() => <UpdateOutlined color="primary" />}
            title="Updated At"
            subtitle={
              paymentAccountDetail?.updatedAt
                ? localizeDateMed(paymentAccountDetail?.updatedAt)
                : "N/A"
            }
          />
        </Grid>
        <Grid item md={12}>
          <InformationTile
            icon={() => <InfoOutlined color="primary" />}
            title="Description"
            subtitle={
              <div>
                {paymentAccountDetail?.description
                  ? ReactHtmlParser(paymentAccountDetail.description)
                  : "N/A"}
              </div>
            }
          />
        </Grid>
      </Grid>
    </Box>
  );
};

export default PaymentAccountBasicDetail;
